export const MessageFrom = Object.freeze({
    avatar: "Avatar",
    user: "User",
});

export const toMessageFrom = (value) => {
    const key = value.toLowerCase();
    return MessageFrom[key] || value;
};